import React from "react";

import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";
import { pluralize } from "@src/utils/pluralize";

import styles from "./ClientNotes.module.css";

interface NotesHeaderProps {
  notesCount: number;
  onFilterClick: () => void;
  onCreateNote: () => void;
  filterComponent?: React.ReactNode;
  filterChip?: React.ReactNode;
  isLoading?: boolean;
}

const NotesHeader: React.FC<NotesHeaderProps> = ({
  notesCount,
  onFilterClick,
  onCreateNote,
  filterComponent,
  filterChip,
  isLoading,
}) => {
  return (
    <div className={styles.titleRow}>
      <div className={styles.leftSection}>
        <Text variant="title3" color="text">
          Notes
        </Text>
        {isLoading ? (
          <Skeleton width={40} />
        ) : (
          <Text variant="bodySmall" color="textSubtle">
            {pluralize(notesCount, "note", true)}
          </Text>
        )}
      </div>
      <div className={styles.rightSection}>
        {filterChip}
        {filterComponent || (
          <IconButton
            IconComponent={FilterListIcon}
            size="medium"
            onClick={onFilterClick}
          />
        )}
        <Button
          onClick={onCreateNote}
          size="small"
          variant="outlined"
          buttonType="secondary"
          text="New Note"
          startIcon={<AddIcon />}
        />
      </div>
    </div>
  );
};

export default NotesHeader;
